import React, { useState, useEffect } from "react";
import bgPattern from "./background_pattern.png";
import { Link} from 'react-router-dom';

export default function TermsOfService() {
  const [lang, setLang] = useState("en");
  const [emailForShow, setEmailForShow] = useState("");
  useEffect(() => {
          // Собираем email динамически
          const user = "mail";
          const domain = "solar-spanish.com";
          setEmailForShow(`${user}@${domain}`);
      }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="min-h-screen bg-neutral-50 p-3 flex flex-col items-center"
      style={{
        backgroundImage: `url(${bgPattern})`,
        backgroundRepeat: "repeat",
        backgroundSize: "auto",
      }}
    >
      
      <div className="w-full max-w-3xl bg-white shadow rounded-2xl p-6 border border-2">
        {/* Language Switcher */}
        <div className="flex justify-between mb-4">
          <Link to="/">
            <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full">
              Go back
            </button>
          </Link>
          <select
            value={lang}
            onChange={(e) => setLang(e.target.value)}
            className="border rounded-xl px-3 py-2 bg-white shadow-sm"
          >
            <option value="en">English</option>
            <option value="ru">Русский</option>
          </select>
        </div>

        {/* English Version */}
        {lang === "en" && (
          <div>
            <h1 className="text-3xl font-bold mb-4">Terms Of Service</h1>
            <p><strong>Last updated:</strong> February 10, 2025</p>
            <p className="mt-4">This Terms of Service (“Agreement”) governs your use of the Solar Spanish mobile application (“Application”, “We”, “Us”).</p>
            <p className="mt-4">By using the Application, you (“User”) confirm that you have read, understood, and agree to be bound by this Agreement.</p>
            <p className="mt-4">If you do not agree with these terms, please discontinue using the Application.</p>
            <h2 className="mt-4 font-bold">1. Use of the Application</h2>
            <h3 className="mt-2">1.1. The Application is designed to help users learn the Spanish language through:</h3>
            <ul>
              <li>- vocabulary learning,</li>
              <li>- spaced repetition system,</li>
              <li>- grammar exercises,</li>
              <li>- verb conjugation practice,</li>
              <li>- listening exercises.</li>
            </ul>
            <h3 className="mt-2">1.2. The Application may be used for personal educational purposes only.</h3>
            <p>You are strictly prohibited from:</p>
            <ul>
              <li>- copying or distributing the learning materials,</li>
              <li>- using the materials for commercial purposes,</li>
              <li>- creating competing services, applications, or courses using the content,</li>
              <li>- providing your access to third parties for compensation.</li>
            </ul>
            <h2 className="mt-2">1.3. Users must be at least 13 years old.</h2>
            <p>Users under 18 must have parental or guardian supervision.</p>
            <h2 className="mt-4 font-bold">2. User Account</h2>
            <h2 className="mt-2">2.1. Access to the Application is provided through third-party authentication services, including:</h2>
            <ul>
              <li>- Apple Sign-In,</li>
              <li>- Google Sign-In.</li>
            </ul>
            <h2 className="mt-2">2.2. You are responsible for maintaining the confidentiality of your login information.</h2>
            <h2 className="mt-2">2.3. We may suspend or terminate access if the User violates this Agreement.</h2>
            <h2 className="mt-4 font-bold">3. Subscriptions and In-App Purchases</h2>
            <h2 className="mt-2">3.1. The Application offers a subscription that provides access to additional learning materials and exercises.</h2>
            <h2 className="mt-2">3.2. All payments are processed exclusively through Apple In-App Purchase, in accordance with Apple’s policies.</h2>
            <h2 className="mt-2">3.3. We do not store any payment information.</h2>
            <p>All payment data is handled by Apple.</p>
            <h2 className="mt-2">3.4. Refunds, cancellations, and payment issues are governed by the Apple App Store Terms & Conditions.</h2>
            <p>Users can manage their subscriptions through their Apple ID account settings.</p>
            <h2 className="mt-4 font-bold">4. Data Collection and Use</h2>
            <h2 className="mt-2">4.1. We collect only the minimum information required to operate the Application, including:</h2>
            <ul>
              <li>- your email and name (provided by the authentication service),</li>
              <li>- technical data such as device type and OS version.</li>
            </ul>
            <h2 className="mt-2">4.2. Detailed information is available in our Privacy Policy.</h2>
            <h2 className="mt-4 font-bold">5. Limitation of Liability</h2>
            <h2 className="mt-2">5.1. The Application is provided on an “as is” basis.</h2>
            <p>We do not guarantee:</p>
            <ul>
              <li>- error-free operation,</li>
              <li>- uninterrupted availability,</li>
              <li>- absolute accuracy of learning materials.</li>
            </ul>
            <p className="mt-2">5.2. We are not responsible for:</p>
            <ul>
              <li>- failures resulting from your device or internet connection,</li>
              <li>- inability to access the Application for reasons beyond our control,</li>
              <li>- consequences arising from misuse of the Application.</li>
            </ul>
            <p className="mt-4 font-bold">6. Prohibited Activities</p>
            <p>Users must not:</p>
            <ul>
              <li>- interfere with or disrupt Application functionality,</li>
              <li>- attempt unauthorized access,</li>
              <li>- decompile, modify, or reverse engineer the Application,</li>
              <li>- use bots or automated scripts,</li>
              <li>- distribute malware or harmful code,</li>
              <li>- use Application materials outside of personal learning.</li>
            </ul>
            <p className="mt-4 font-bold">7. No User-to-User Communication</p>
            <p>The Application does not include chats, forums, messaging, or any form of communication between users.</p>
            <p className="mt-4 font-bold">8. Modifications to the Agreement</p>
            <p>We may update this Agreement from time to time.</p>
            <p>The “Last updated” date reflects the most recent changes.</p>
            <p>Continued use of the Application after updates constitutes acceptance of the new terms.</p>
            <h2 className="mt-4 font-bold">9. Contact Information</h2>
            <p>If you have any questions about this Agreement, you may contact us:</p>
            <p>Email: <a href={`mailto:${emailForShow}`} style={{ textDecoration: "none", color: "black" }}>{emailForShow}</a></p>
            <p>Website: <a href="https://solar-spanish.com">https://solar-spanish.com</a></p>
          </div>
        )}

        {/* Russian Version */}
        {lang === "ru" && (
          <div>
            <h1 className="text-3xl font-bold mb-4">Пользовательское соглашение</h1>
            <p><strong>Последнее обновление:</strong> 10 февраля 2025 г.</p>
            <p className="mt-4">Настоящее Пользовательское соглашение («Соглашение») регулирует использование приложения Solar Spanish («Приложение»), предоставляемого («Мы», «Наша Компания», «Нас»).</p>
            <p className="mt-4">Используя Приложение, Вы («Пользователь») подтверждаете, что прочитали, поняли и согласны соблюдать условия настоящего Соглашения.</p>
            <p className="mt-4">Если Вы не согласны с условиями, пожалуйста, прекратите использование Приложения.</p>
            <h2 className="mt-4 font-bold">1. Использование Приложения</h2>
            <h3 className="mt-2">1.1. Приложение предназначено для обучения испанскому языку, включая:</h3>
            <ul>
              <li>- изучение слов,</li>
              <li>- повторение по системе интервальных повторений,</li>
              <li>- упражнения по грамматике,</li>
              <li>- тренировки спряжений глаголов,</li>
              <li>- упражнения на слушание.</li>
            </ul>
            <h3 className="mt-2">1.2. Приложение можно использовать исключительно в личных образовательных целях.</h3>
            <p>Строго запрещается:</p>
            <ul>
              <li>- копировать или распространять материалы Приложения;</li>
              <li>- использовать материалы Приложения в коммерческих целях;</li>
              <li>- создавать на основе материалов свои учебные курсы, сервисы или приложения;</li>
              <li>- предоставлять доступ к Приложению третьим лицам за вознаграждение.</li>
            </ul>
            <h2 className="mt-2">1.3. Пользователь должен быть старше 13 лет.</h2>
            <p>Лица младше 18 лет должны использовать Приложение под контролем родителей или законных представителей.</p>
            <h2 className="mt-4 font-bold">2. Аккаунт Пользователя</h2>
            <h2 className="mt-2">2.1. Вход в Приложение осуществляется через сторонних поставщиков аутентификации:</h2>
            <ul>
              <li>- Apple Sign-In,</li>
              <li>- Google Sign-In.</li>
            </ul>
            <h2 className="mt-2">2.2. Пользователь несёт ответственность за сохранение конфиденциальности своих данных для входа.</h2>
            <h2 className="mt-2">2.3. Мы можем ограничить или заблокировать доступ, если Пользователь нарушает условия настоящего Соглашения.</h2>
            <h2 className="mt-4 font-bold">3. Подписки и покупки</h2>
            <h2 className="mt-2">3.1. В Приложении доступна подписка, которая открывает доступ к дополнительным учебным материалам и расширенным упражнениям.</h2>
            <h2 className="mt-2">3.2. Все покупки осуществляются через Apple In-App Purchase в соответствии с правилами Apple.</h2>
            <h2 className="mt-2">3.3. Мы не храним платежные данные Пользователя.</h2>
            <p>Все операции обрабатываются Apple.</p>
            <h2 className="mt-2">3.4. Вопросы оплаты, отмены подписки, возврата средств регулируются политикой Apple App Store.</h2>
            <p>Пользователь может управлять подпиской в настройках своего Apple ID.</p>
            <h2 className="mt-4 font-bold">4. Сбор и использование данных</h2>
            <h2 className="mt-2">4.1. Мы собираем минимально необходимую информацию для работы Приложения, включая:</h2>
            <ul>
              <li>- имя и email, указанные пользователем;</li>
              <li>- технические данные (тип устройства, версия ОС и т.п.).</li>
            </ul>
            <h2 className="mt-2">4.2. Подробная информация представлена в Политике конфиденциальности.</h2>
            <h2 className="mt-4 font-bold">5. Ограничение ответственности</h2>
            <h2 className="mt-2">5.1. Приложение предоставляется «как есть» («as is»).</h2>
            <p>Мы не гарантируем:</p>
            <ul>
              <li>- отсутствие ошибок,</li>
              <li>- постоянную доступность Приложения,</li>
              <li>- абсолютную точность учебных материалов.</li>
            </ul>
            <p className="mt-2">5.2. Мы не несем ответственности за:</p>
            <ul>
              <li>- сбои в работе устройства Пользователя,</li>
              <li>- невозможность доступа к Приложению по причинам, не зависящим от нас,</li>
              <li>- последствия неправильного использования Приложения.</li>
            </ul>
            <p className="mt-4 font-bold">6. Запрещенные действия</p>
            <p>Запрещается:</p>
            <ul>
              <li>- вмешиваться в работу Приложения;</li>
              <li>- пытаться получить несанкционированный доступ;</li>
              <li>- декомпилировать или модифицировать приложение;</li>
              <li>- использовать автоматизированные скрипты или ботов;</li>
              <li>- распространять вредоносный код;</li>
              <li>- использовать материалы Приложения вне личных образовательных целей.</li>
            </ul>
            <p className="mt-4 font-bold">7. Отсутствие коммуникации между пользователями</p>
            <p>В Приложении нет чатов, форумов, обмена сообщениями или любых форм общения между пользователями.</p>
            <p className="mt-4 font-bold">8. Право на изменение условий</p>
            <p>Мы можем периодически обновлять настоящее Соглашение.</p>
            <p>Дата последнего изменения указывается в начале документа.</p>
            <p>Продолжение использования Приложения означает согласие с обновлённой версией.</p>
            <h2 className="mt-4 font-bold">9. Контакты</h2>
            <p>По вопросам, связанным с использованием Приложения, Вы можете связаться с нами:</p>
            <p>Email: <a href={`mailto:${emailForShow}`} style={{ textDecoration: "none", color: "black" }}>{emailForShow}</a></p>
            <p>Сайт: <a href="https://solar-spanish.com">https://solar-spanish.com</a></p>
          </div>
        )}
      </div>
    </div>
  );
}

